import {Routes} from '@angular/router';
import {EditPageComponent} from './edit-page.component';
import {AuthGuard} from '../../../../guards/auth.guard';
import {IsCompletedUserDataGuard} from '../../../../guards/is-completed-user-data.guard';
import {responseToCallRoutes} from '../response-to-call/response-to-call.routes';
import {generalLetterRoutes} from '../general-letter/general-letter.routes';
import {documentsInformationRoutes} from '../documents-information/documents-information.routes';
import {forestTaxLi1Routes} from '../forest-tax-li-1.routes';
import {forestTaxDl1Routes} from '../forest-tax-dl-1.routes';
import {propertyTaxIn1Routes} from '../property-tax-in-1.routes';
import {propertyTaxDn1Routes} from '../property-tax-dn-1.routes';
import {agriculturalTaxIr1Routes} from '../agricultural-tax-ir-1.routes';
import {agriculturalTaxDr1Routes} from '../agricultural-tax-dr-1.routes';
import {meansOfTransportTaxDt1Routes} from '../means-of-transport-tax-dt-1.routes';
import {municipalWasteDisposalRoutes} from '../municipal-waste-disposal/municipal-waste-disposal.routes';
import {alcoholicSalesPermitRoutes} from '../ alcoholic-sales-permit/ alcoholic-sales-permit.routes';
import {contactDataUpdateRoutes} from "../contact-data-update/contact-data-update.routes";
import {realEstateLeasingRoutes} from "../real-estate-leasing/real-estate-leasing.routes";
import {perpetualUsufructRoutes} from "../perpetual-usufruct/perpetual-usufruct.routes";

export const applicationEditPageRoutes: Routes = [
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/odpowiedz-na-wezwanie',
    children: responseToCallRoutes,
    data: {
      contentUrl: 'odpowiedz-na-wezwanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/uzupelnienie-dokumentow',
    children: documentsInformationRoutes,
    data: {
      contentUrl: 'uzupelnienie-dokumentow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/pismo-ogolne',
    children: generalLetterRoutes,
    data: {
      contentUrl: 'pismo-ogolne'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/podatek-lesny-il-1',
    children: forestTaxLi1Routes,
    data: {
      contentUrl: 'podatek-lesny-il-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/podatek-lesny-dl-1',
    children: forestTaxDl1Routes,
    data: {
      contentUrl: 'podatek-lesny-dl-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/podatek-od-nieruchomosci-in-1',
    children: propertyTaxIn1Routes,
    data: {
      contentUrl: 'podatek-od-nieruchomosci-in-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/podatek-od-nieruchomosci-dn-1',
    children: propertyTaxDn1Routes,
    data: {
      contentUrl: 'podatek-od-nieruchomosci-dn-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/podatek-rolny-ir-1',
    children: agriculturalTaxIr1Routes,
    data: {
      contentUrl: 'podatek-rolny-ir-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/podatek-rolny-dr-1',
    children: agriculturalTaxDr1Routes,
    data: {
      contentUrl: 'podatek-rolny-dr-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/podatek-od-srodki-transportowe-dt-1',
    children: meansOfTransportTaxDt1Routes,
    data: {
      contentUrl: 'podatek-od-srodki-transportowe-dt-1'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wywoz-odpadow-komunalnych',
    children: municipalWasteDisposalRoutes,
    data: {
      contentUrl: 'wywoz-odpadow-komunalnych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zezwolenie-sprzedaz-napojow-alkoholowych',
    children: alcoholicSalesPermitRoutes,
    data: {
      contentUrl: 'zezwolenie-sprzedaz-napojow-alkoholowych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/aktualizacja-danych-kontaktowych-wpio-20',
    children: contactDataUpdateRoutes,
    data: {
      contentUrl: 'aktualizacja-danych-kontaktowych-wpio-20'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wydzierzawienie-nieruchomosci',
    children: realEstateLeasingRoutes,
    data: {
      contentUrl: 'wydzierzawienie-nieruchomosci'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/wieczyste-uzytkowanie',
    children: perpetualUsufructRoutes,
    data: {
      contentUrl: 'wieczyste-uzytkowanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
];
